/*eslint no-unused-vars: [0]*/
import {
	SET_CART_ITEM,
	ADD_PRODUCT_TO_CART,
	REMOVE_PRODUCT_FROM_CART,
	SET_QUANTITY,
	UPDATE_ORDER,
	UPDATE_ORDER_SUCCESS,
	UPDATE_ORDER_FAIL,
	OPEN_CART_LIST_DRAWER,
	CLOSE_CART_LIST_DRAWER,
	FETCH_CART,
	FETCH_CART_SUCCESS,
	FETCH_CART_FAIL,
	CLEAR_CART
} from '../constants/ActionTypes';

export const addProductToCart = (product, eventID, partnerPortalSettings) => {
	return {
		type: ADD_PRODUCT_TO_CART,
		product: product,
		eventID: eventID,
		partnerPortalSettings: partnerPortalSettings
	};
};

export const removeProductFromCart = (orderRowID) => {
	return {
		type: REMOVE_PRODUCT_FROM_CART,
		orderRowID: orderRowID
	};
};

export const fetchCart = (eventID) => {
	return {
		type: FETCH_CART,
		eventID: eventID
	};
};

export const fetchCartSuccess = (order) => {
	return {
		type: FETCH_CART_SUCCESS,
		order: order
	};
};

export const fetchCartFail = (error) => {
	return {
		type: FETCH_CART_FAIL,
		error: error
	};
};

export const updateOrder = (order, checkout, eventID, partnerPortalSettings) => {
	return {
		type: UPDATE_ORDER,
		order: order,
		checkout: checkout,
		eventID: eventID,
		partnerPortalSettings: partnerPortalSettings,
		loading: true
	};
};

export const updateOrderSuccess = (data) => {
	return {
		type: UPDATE_ORDER_SUCCESS,
		payload: data,
		loading: false
	};
};

export const updateOrderFail = (error) => {
	return {
		type: UPDATE_ORDER_FAIL,
		error: error,
		loading: false
	};
};

export const setQuantity = (productID, quantity, orderRowID) => {
	return {
		type: SET_QUANTITY,
		productID: productID,
		quantity: quantity,
		orderRowID: orderRowID
	};
};

export const openCartListDrawer = () => {
	return {
		type: OPEN_CART_LIST_DRAWER,
		cartListDrawerOpened: true
	};
};

export const closeCartListDrawer = () => {
	return {
		type: CLOSE_CART_LIST_DRAWER,
		cartListDrawerOpened: false
	};
};
export const clearCart = () => {
	return {
		type: CLEAR_CART
	}
}
